import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Phone, ArrowRight } from 'lucide-react';

const CTASection = () => {
  return (
    <section data-testid="cta-section" className="py-20 md:py-32 bg-primary relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
          Ready to Get Your Appliances Fixed?
        </h2>
        <p className="text-xl text-white/80 mb-10 max-w-2xl mx-auto">
          Book your appointment online or give us a call. Our expert technicians are standing by 
          to help you 7 days a week.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link to="/book">
            <Button
              data-testid="cta-book-btn"
              size="lg"
              className="bg-accent hover:bg-accent/90 text-white font-semibold px-8 py-6 text-lg rounded-full btn-shine shadow-lg"
            >
              Book Online Now
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </Link>
          <a href="tel:+18556056034">
            <Button
              data-testid="cta-call-btn"
              size="lg"
              variant="outline"
              className="bg-white/10 border-2 border-white text-white hover:bg-white hover:text-primary font-semibold px-8 py-6 text-lg rounded-full"
            >
              <Phone className="w-5 h-5 mr-2" />
              (855) 605-6034
            </Button>
          </a>
        </div>

        <p className="text-white/60 mt-8 text-sm">
          Service Call Fee — PA: $89-$129 | NJ: $99-$149 (varies by brand & model)
        </p>
      </div>
    </section>
  );
};

export default CTASection;
